import React, { FC } from "react";
import LoadingDots from "../../assets/gif/Loader_dots.json";
import CommonGifAnimation from "../CustomGifAnimation/CommonGifAnimation";
import { Box, Typography } from "@mui/material";
import "./CustomThreeDotsLoader.scss";
import { Colors } from "../../styles/constant";

interface Props {
  withText?: boolean;
  textContent?: any;
  isOverLayRequired?:boolean;
}

const CustomThreeDotsLoader: FC<Props> = ({
  withText = false,
  textContent = null,
  isOverLayRequired = true
}) => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        overflow={"hidden"}
      >
        <CommonGifAnimation animationData={LoadingDots} heightCustom="3rem" />
        {withText ? (
          <Box textAlign="center" marginTop="0.5rem">
            {textContent ? (
              textContent
            ) : (
              <>
                <Typography
                  variant="h6"
                  fontWeight="400"
                  color={Colors.descriptionGray}
                >
                  Just a few moments...
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="400"
                  color={Colors.descriptionGray}
                >
                  Ensuring everything is up-to-date
                </Typography>{" "}
              </>
            )}
          </Box>
        ) : null}
      </Box>
      {
        isOverLayRequired && <div className="loader-overlay"></div>
      }
      
    </>
  );
};
export default CustomThreeDotsLoader;
